import { Outlet, createRootRoute } from '@tanstack/react-router'
import { AppShell } from '@/components/AppShell'
import { SignInGate } from '@/features/access/SignInGate'
import { SettingsBootstrap } from '@/features/settings/SettingsBootstrap'
import { ErrorState } from '@/components/States'

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: () => (
    <div className="mx-auto max-w-2xl px-4">
      <ErrorState />
    </div>
  ),
})

function RootLayout() {
  return (
    <SignInGate>
      <SettingsBootstrap />
      <AppShell>
        <Outlet />
      </AppShell>
    </SignInGate>
  )
}
